import { useEffect } from 'react'

type Props = {
  enabled: boolean
  id: string
  src: string
  onLoad?: () => void
}
export const useLoadScript = ({ enabled, id, src, onLoad }: Props) => {
  useEffect(() => {
    if (enabled) {
      loadScript()
    }
    return () => {
      if (enabled) {
        unLoadScript()
      }
    }
  }, [])

  const loadScript = () => {
    const script = document.createElement('script')
    script.id = id
    script.src = src
    script.async = true
    script.defer = true
    script.onload = () => {
      if (onLoad) onLoad()
    }

    document.head.appendChild(script)
  }

  const unLoadScript = () => {
    const script = document.getElementById(id)
    try {
      script?.parentNode?.removeChild(script)
    } catch (error) {
      console.error(`Failed to unLoad ${id} script : `, error)
    }
  }
}
